import React, { useState, useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

import './styles/App.css';
import './styles/Form.css';
import './styles/dashboard/Form.css';
import './styles/dashboard/util.css';
import './styles/variables.css';
import './styles/FormValidation.css';

import LandingPage from "./components/landingpage/LandingPage";
import ConnectDepop from './components/dashboard/ConnectDepop';
import Dashboard from './components/dashboard/Dashboard';

import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

function App() {

    useEffect(() => {
        smoothscroll.polyfill();
    }, []);
    
    const [loggedIn, setLoggedIn] = useState(false);
    const ProtectedRoute = ({ component: Component, componentProps, ...rest }) => {
        return (
            <Route
            {...rest} 
            render={(props) => 
                loggedIn ? 
                <Component 
                {...props} 
                {...componentProps} />
                : <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }} />
            }/>
        )
    };
    const handleLogin = () => {
        // Login auth check within landing page component.
        setLoggedIn(true);
    };

    const handleLogOut = (e) => {
        e.preventDefault();
        console.log("logged out!");
        setLoggedIn(false);
    }
    return (
        <Router>
            <Switch>
                <ProtectedRoute
                path="/connectdepop"
                component={ConnectDepop} />
                <ProtectedRoute 
                path="/dashboard"
                component={Dashboard} 
                componentProps={{handleLogOut: handleLogOut}}/>
                <Route 
                path="/"
                render={(props) => {
                    return <LandingPage {...props} 
                    loggedIn={loggedIn}
                    handleLogin={handleLogin} />
                }} />
            </Switch>
        </Router>
    );
}

export default App;
